import { parseJSON } from "./parseJSON";
import { getToken } from "../utils/authUtils";

const urlBase = `${process.env.API_URL}/region`;
const readUrl = (url = "") => `${urlBase}/${url}`;

export const fetchRegiones = async () => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(""), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};
